import { FormType, HELP_CENTER_URL, PropertyTypes } from '@aloft/toolkit-shared';
import { Block, Flex, Link, Typography } from '@aloft/toolkit-sui';

import { ExportModalSelectFormType } from './ExportModalSelectFormType.tsx';

export const ExportModalAppraiseItProExport = ({
  formType,
  setFormType,
  propertyType = 'singleFamilyResidence',
}: {
  formType: FormType;
  setFormType: (val: FormType) => void;
  propertyType: PropertyTypes | undefined;
}) => (
  <Flex flexDirection="column">
    <Typography variant="h3">Export to Appraise-It Pro</Typography>
    <Typography variant="body1">
      Your export will include your adjustments, cost approach and workfile documentation.
      Currently, FNMA 1004, FNMA 1004C, FNMA 1025, and FNMA 2055 are supported.
    </Typography>
    <Block height=".5rem" />
    <Typography variant="body1">
      <Link isExternal href={HELP_CENTER_URL}>
        Need help? Check out this article.
      </Link>
    </Typography>
    <ExportModalSelectFormType
      formType={formType}
      setFormType={setFormType}
      options={getFormOptions(propertyType)}
    />
  </Flex>
);

const getFormOptions = (propertyType: PropertyTypes): { value: FormType; label: string }[] => {
  switch (propertyType) {
    case 'singleFamilyResidence':
      return [
        { value: FormType.fnma1004, label: 'FNMA 1004' },
        { value: FormType.fnma2055, label: 'FNMA 2055' },
      ];
    case 'multiFamily':
      return [{ value: FormType.fnma1025, label: 'FNMA 1025' }];
    case 'manufacturedHome':
      return [{ value: FormType.fnma1004c, label: 'FNMA 1004C' }];
    default:
      throw new Error(`This property type (${propertyType}) is not yet supported.`);
  }
};
